import React from 'react';
import AtlasV2DoubleDropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DoubleDropdownMetricColumnChart';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Paid Traffic TopEntity chart
 */
const AtlasV2PaidTrafficByTopEntity = () => {
  const mainEntityType = useMainEntityType();

  return (
    <AtlasV2DoubleDropdownMetricColumnChart
      useAdvancedSearchDataArgs={{
        addFieldsFromPrimaryResponse: true
      }}
      fields={[
        { fieldName: 'adClicks', label: 'Paid Traffic' },
        { fieldName: 'adSpend', label: 'Paid Ad Spend' }
      ]}
      groupByFields={[
        {
          id: 'searchTerm',
          label: 'Keyword',
          indexName: 'traffic'
        },
        {
          id: 'brandId',
          label: 'Brand',
          indexName: 'traffic'
        },
        {
          id: 'categoryId',
          label: 'Category',
          indexName: 'traffic'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory',
          indexName: 'traffic'
        },

        {
          id: 'stacklineSku',
          label: 'Product',
          indexName: 'traffic'
        },
        {
          id: 'parentBrandId',
          label: 'Manufacturer',
          indexName: 'traffic'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
    />
  );
};

export default AtlasV2PaidTrafficByTopEntity;
